<template>
  <nx-dialog :value="active"
             @input="close"
             max-width="400px"
             icon="delete"
             :title="$t('message.entity.actions.delete')">
    <p v-if="text">
      <label v-text="text"></label>
    </p>
    <p v-if="!published">{{ $t(`message.entity.actions.deleteWarning`) }}</p>
    <template slot="actions">
      <v-btn color="secondary"
             flat
             :disabled="loading"
             @click="close"
      >{{ $t('message.common.close') }}
      </v-btn>
      <v-btn v-if="!published"
             color="secondary"
             flat
             :loading="loading"
             @click="handleDelete"
      >{{ $t('message.common.accept') }}
      </v-btn>
    </template>
  </nx-dialog>
</template>

<script>
import StorableEditorComponent from '@/mixins/storable-editor-component';
import NxDialog from '@/components/dialogs/Dialog';

export default {
  name: 'nx-entity-delete-action',
  mixins: [StorableEditorComponent],
  components: {
    NxDialog,
  },
  data() {
    return {
      loading: false,
      active: false,
    };
  },
  computed: {
    published() {
      return this.state.master.published || false;
    },
    hasUrlSelected() {
      return this.getters.hasUrlSelected;
    },
    text() {
      if (this.published) {
        return this.$t('message.entity.actions.decisionDeletePublishedWarning');
      }
      if (this.hasUrlSelected) {
        return this.$t('message.entity.actions.decisionDeleteUrlWarning');
      }
      return null;
    },
  },
  methods: {
    close() {
      this.active = false;
      this.$emit('close');
    },
    async handleDelete() {
      this.loading = true;
      await this.dispatch('DELETE');
      this.close();
      this.loading = false;
    },
  },
  mounted() {
    this.active = true;
  },
};
</script>
